module.exports = __webpack_public_path__ + "static/img/tky-kcbg4-nor@2x.79fbbf3e.png";